<template>
  <div class="summary">
    <AppLoader :isLoading="isLoading || data.isLoading2"/>
    <!-- итоговая часть -->
    <AppParagraph title="Барабан" v-if="result?.tube">
      <AppParameter title="Даметр, м." :value="result?.tube?.diameter || 'нет данных'"></AppParameter>
      <AppParameter title="Длина, м." :value="result?.tube?.length || 'нет данных'"></AppParameter>
      <AppParameter title="Материал" :value="result?.tube?.material || 'нет данных'"></AppParameter>
      <AppParameter title="Стоимость, р." :value="result?.tube?.priceFormated || 'нет данных'"></AppParameter>
      <label><input type="checkbox" v-model="data.selected.tube"/>Выбрать</label>
    </AppParagraph>
    <AppParagraph title="Узлы" v-if="result?.tube?.nodes">
      <AppParameter title="Бандаж, р."
                    :value="result?.tube?.nodes?.bandage.priceFormated || 'нет данных'"></AppParameter>
      <AppParameter title="Венец, р." :value="result?.tube?.nodes?.crown.priceFormated || 'нет данных'"></AppParameter>
      <AppParameter title="Ролик опорный, р."
                    :value="result?.tube?.nodes?.supportRoller.priceFormated || 'нет данных'"></AppParameter>
      <AppParameter title="Ролик упорный, р."
                    :value="result?.tube?.nodes?.thrustRoller.priceFormated || 'нет данных'"></AppParameter>
    </AppParagraph>
    <AppParagraph title="Горелка" v-if="result?.burner">
      <AppParameter title="Наименование" :value="result?.burner?.name || 'нет данных'"></AppParameter>
      <AppParameter title="Стоимость, р." :value="result?.burner?.priceFormated || 'нет данных'"></AppParameter>
      <label><input type="checkbox" v-model="data.selected.burner"/>Выбрать</label>
    </AppParagraph>
    <AppParagraph title="Аспирация" v-if="result?.aspirations?.length">
      <div v-for="(aspiration, index) in  result?.aspirations" :key="aspiration.title">
        <div>{{ index + 1 }}. {{ aspiration.title }}:</div>
        <AppParameter title="В составе"></AppParameter>
        <AppParameter :title="'- ' + node.type" :value="node.title" v-for="node of aspiration.nodes"
                      :key="node"></AppParameter>
        <AppParameter title="Стоимость" :value="aspiration.priceFormated"></AppParameter>
        <label><input ref="aspiration" type="checkbox" v-model="data.selected.asp[index]"
                      @change="updateAspirationSelect(index)"/>Выбрать</label>
        <br><br>
      </div>
    </AppParagraph>
    <AppParagraph title="Детали расчета" v-if="result?.details">
      <AppParagraph v-for="(sheet, index) in result.details" :title="index" :key="index">
        <AppParameter v-for="cell in Object.keys(sheet)" :title="cell" :key="cell">{{ sheet[cell] }}<br></AppParameter>
      </AppParagraph>
    </AppParagraph>


    <AppParagraph title="Внимание" v-if="result?.cautions?.length">
      <AppParameter v-for="caution of result.cautions" :value="caution" :key="caution"></AppParameter>
    </AppParagraph>

    <div class="summary_end">
      <AppParagraph title="Стоимость от, р.">
        <div class="field price ellipsis">{{ price2 || 0 }}</div>
      </AppParagraph>

      <AppParagraph title="Получить предложение">
        <AppButtonSubmit title="Отправить заявку" @submit="contactUs"></AppButtonSubmit>
      </AppParagraph>
    </div>
  </div>
</template>
<script setup>
import AppParagraph from "@/components/ui/AppParagraph.vue";
import AppParameter from "@/components/ui/AppParameter.vue";
import AppButtonSubmit from "@/components/ui/AppButtonSubmit.vue";
import AppLoader from "@/components/ui/AppLoader.vue";

import {computed, defineProps, reactive} from 'vue'
import {useAxios} from "@/composables/axios";

const props = defineProps({
  inputs: {
    type: Object
  },
  result: {
    type: Object
  },
  isLoading: {
    type: Boolean,
    default: false
  }
})

const data = reactive({
  price: 0,
  aspiration: {},
  selected: {
    tube: false,
    burner: false,
    asp: [
      false,
      false,
      false,
    ]
  },
  isLoading2: false
})

let price2 = computed(() => {

  let p = 0
  if (data.selected.tube) {
    p += props.result.tube.price
  }

  if (data.selected.burner) {
    p += props.result.burner.price
  }

  if (data.selected.asp[0]) {
    p += props.result.aspirations[0].price
  }

  if (data.selected.asp[1]) {
    p += props.result.aspirations[1].price
  }

  if (data.selected.asp[2]) {
    p += props.result.aspirations[2].price
  }

  if (p === 0) {
    return '-'
  }

  return formatter(p);
})


function formatter(value) {
  let formatter = new Intl.NumberFormat('ru-RU', {
    style: 'currency',
    currency: 'RUB',
  });

  return formatter.format(value);
}


function updateAspirationSelect(index) {
  if (!data.selected.asp[index]) {
    return
  }

  data.selected.asp.forEach((item, index2) => {
    if (index2 !== index) {
      data.selected.asp[index2] = false
    }
  })
}

function contactUs(params) {
  let data2 = {
    inputs: {},
    outputs: {},
    selected: {},
    sum: price2.value,
    contacts: {
      "Почта": params.email,
      "Телефон": params.phone
    }
  }

  for (const key in props.inputs) {
    data2.inputs[props.inputs[key].title || key] = props.inputs[key].value
  }

  if (props.result?.tube) {
    let n = `Барабан ${props.result?.tube?.diameter}x${props.result?.tube?.length} ${props.result?.tube?.material}`
    data2.outputs[n] = formatter(props.result?.tube?.price)
    if (data.selected.tube) {
      data2.selected.tube = n
    }
  }

  if (props.result?.burner) {
    data2.outputs['Горелка ' + props.result?.burner.name] = formatter(props.result?.burner?.price)
  }

  for (const key in props.result?.aspirations) {
    data2.outputs[props.result?.aspirations[key].title] = formatter(props.result?.aspirations[key].price)
    if (data.selected.asp[key]) {
      data2.selected[`asp${key}`] = props.result?.aspirations[key].title
    }
  }

  data.isLoading2 = true
  useAxios().post('/notification', data2)
    .then(() => {
      data.isLoading2 = false
      alert("Заявка успешно отправлена")
    })
    .catch(() => {
      data.isLoading2 = false
      alert("Не удалось отправить заявку")
    });
}

</script>

<style scoped>
.summary {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.summary_end {
  margin-top: auto;
  margin-bottom: 5px;
  display: flex;
  flex-direction: column;
}

input[type=checkbox] {
  cursor: pointer;
}
</style>
